import React from 'react'

import {type RenderTabBarFnProps} from '#/view/com/pager/Pager'
import {TabBar} from '../pager/TabBar'
import {HomeHeaderLayout} from '../home/HomeHeaderLayout'

export function PostsHeader(
  props: RenderTabBarFnProps & {
    testID?: string
    onPressSelected: () => void
    tabNames: string[]
  },
) {
  const {tabNames} = props

  const items = React.useMemo(() => {
    return tabNames
  }, [tabNames])

  const onSelect = React.useCallback(
    (index: number) => {
      if (props.onSelect) {
        props.onSelect(index)
      }
    },
    [props],
  )

  return (
    <HomeHeaderLayout tabBarAnchor={props.tabBarAnchor} hideFeedsIcon>
      <TabBar
        key={items.join(',')}
        onPressSelected={props.onPressSelected}
        selectedPage={props.selectedPage}
        onSelect={onSelect}
        testID={props.testID}
        items={items}
        dragProgress={props.dragProgress}
        dragState={props.dragState}
      />
    </HomeHeaderLayout>
  )
}
